const TOUR_POPOVER_CLASS = 'aula-tour';
const TOUR_POPOVER_DARK_CLASS = 'aula-tour-dark';

export const getHomeTourPopoverClass = (isDarkMode: boolean): string =>
  isDarkMode
    ? `${TOUR_POPOVER_CLASS} ${TOUR_POPOVER_DARK_CLASS}`
    : TOUR_POPOVER_CLASS;

export const getHomeTourOverlayColor = (isDarkMode: boolean): string =>
  isDarkMode ? '#000000' : '#1a1a2e';

export const getHomeTourOverlayOpacity = (isDarkMode: boolean): number =>
  isDarkMode ? 0.72 : 0.55;
